
import state from './../../../../../zviz2/zviz/state';
import {Controller as PathController} from './../../../../../zviz2/zviz/components/path';



class Controller extends PathController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        
    }

    setRenderOutput(output){
        super.setRenderOutput(output);
        output.result.setAttribute('d', this.blueprint.private.path);
    }

    getColor(){
        // if(this.data.isHover){
        //     if(this.data.color.length>3){
        //         let color = this.data.color.slice(0,3);
        //         color.push(Math.min(1, 1.3*this.data.color[3]));
        //         return 'rgba(' + color.join(',') + ')';
        //     }
        // }else if(this.data.selected){
        //     return (this.data.color.length>3? 'rgba(': 'rgb(') + this.data.color.join(',') + ')';
        // }
        if(this.data.selected){
            return 'url(#mapGradientHighlight)';
        }
        return 'url(#mapGradient)';

    }

    hasVectorEffect(){
        if(this.renderOutput && this.renderOutput.result){
            return (this.renderOutput.result.style.vectorEffect !== undefined);
        }
        return false;
    }

} 


let Blueprint = {
    type: Controller,
    properties: {
        style: {
            fill: (ctrl) => ( ctrl.getColor() ),
            stroke: 'rgb(229,240,249)', //rgba(255,255,255,0.6)',
            strokeWidth: (ctrl) => (ctrl.hasVectorEffect()? '1px': '0.002px'),
            vectorEffect: (ctrl) => (ctrl.hasVectorEffect()? 'non-scaling-stroke': null),
            fillOpacity: (ctrl) => (ctrl.data.opacity)
            // vectorEffect: 'non-scaling-stroke'   // we can use this for firefox to fix invisible lines, but it doesn't work in IE
        },
        data: {
            id: '',
            selected: false,
            data: null,
            isHover: false,
            opacity: 1,
            color: [180,180,180]
        },
        attributes: {
            id: (ctrl) => ( ctrl.data.id )
        },
    },
    events: {
        mouseover: (event, ctrl) => {
            if(ctrl.data.data && ctrl.data.data.id3 && ctrl.data.selected){
                state.set('map.itemHover', ['id3', ctrl.data.data.id3]);
            }
        },
        mouseout: (event, ctrl) => {
            if(ctrl.data.data && ctrl.data.data.id3){
                state.set('map.itemHover', false);
            }
        },
        click: (event, ctrl) => {
            if(! ctrl.data.selected){
                state.set('map.countryHighlight', null);
                return;
            }
            let t = Date.now() - ctrl.getByUid('map').panTime;
            if(t < 500){ 
                return; 
            }
            let val = {type: 'id3', value: ctrl.data.data.id3};
            if(ctrl.data.data.region == 'great_lakes_region' || ctrl.data.data.region == 'horn_of_africa'){
                val.region = ctrl.data.data.region;
            }
            state.set('map.countryHighlight', val);
        }
    },
    private: {
        path: ''
    },
}


export default Blueprint;
export {Controller, Blueprint};

